import { render } from "./PasswordChangeDialog.vue?vue&type=template&id=50d09cca"
import script from "./PasswordChangeDialog.vue?vue&type=script&lang=js"
export * from "./PasswordChangeDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__